// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "wcc-droparea{position:relative;display:flex;justify-content:center;align-items:center;border:1px dashed #c6c6c6;cursor:pointer;box-shadow:0 0 0 0 transparent;transition:box-shadow .4s ease-in-out}wcc-droparea .droparea-label{text-align:center;animation-duration:350ms}wcc-droparea .droparea-label p:last-child{margin-bottom:0}wcc-droparea.active{box-shadow:0 0 10px 0px #fff}wcc-droparea.active,wcc-droparea:hover{color:#5ca2dd;border-color:#5ca2dd}", ""]);
// Exports
module.exports = exports;
